export default __webpack_public_path__ + "static/media/fossil3.c4a7660d.png";